#@import Booking.Presenters.Picker
#@export Booking.Presenters.DateTimePicker

class Booking.Presenters.DateTimePicker extends Booking.Presenters.Picker
  selected: ->
    @model.getSelectedTimes()

  isSelectable: ->
    true

  toHash: ->

    selectedTimes = @selected()
    loading = @isLoading()

    if selectedTimes?.length and not loading
      date = selectedTimes[0].start()
      multiple = selectedTimes.length > 1

    hash = Booking.Presenters.Picker::toHash.apply this, arguments

    hash.loading = loading if loading
    hash.multiple = multiple

    if !loading and date
      hash.selectedDate =
        day: date.format 'ddd'
        month: date.format 'MMM'
        date: date.format 'D'
        time: date.format 'h:mm A'
    hash
